var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99876 2.31582C6.9233 0.835644 9.0791 0.835644 10.0036 2.31582C10.4196 2.98134 11.1392 3.39693 11.9236 3.42422C13.6673 3.48464 14.7458 5.35068 13.9265 6.89102C13.5576 7.58415 13.5576 8.41566 13.9265 9.10879C14.7462 10.6492 13.6675 12.5161 11.9236 12.5766C11.1391 12.6039 10.4195 13.0193 10.0036 13.685C9.07911 15.1651 6.92332 15.1651 5.99876 13.685C5.60883 13.0607 4.95149 12.6568 4.22435 12.5863L3.91673 12.5658C2.26864 12.4001 1.28175 10.6011 2.07591 9.10879C2.44466 8.4157 2.44473 7.58408 2.07591 6.89102C1.28198 5.39872 2.26875 3.60069 3.91673 3.43496L4.22435 3.41445C4.9514 3.34396 5.6088 2.93995 5.99876 2.31582ZM8.00071 5.46035C6.59763 5.46043 5.46068 6.59755 5.46068 8.00039C5.46083 9.4031 6.59773 10.5404 8.00071 10.5404C9.40377 10.5404 10.5416 9.40315 10.5417 8.00039C10.5417 6.5975 9.40386 5.46035 8.00071 5.46035Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4aebea5041fb9e0f9014953710ebbb17.svg";
export { ForwardRef as ReactComponent };